<div class="row h-100">
    <div class="col-2 placeholder-glow d-flex align-items-end" *ngFor="let p of randomPercentages">
        <div class="placeholder bg-secondary w-100" [style.height.%]="p"></div>
    </div>
</div>